import axios from 'axios'
import { getAuthorizedConfiguration } from '../helpers/RequestHelper'

export const IS_LOADING_CATEGORIES = 'IS_LOADING_CATEGORIES'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const IS_CREATING_CATEGORY = 'IS_CREATING_CATEGORY'
export const ADD_CATEGORY = 'ADD_CATEGORY'

export const CATEGORIES_ENDPOINT = '/content-assets/categories'

export const isLoadingCategories = (status) => ({ type: IS_LOADING_CATEGORIES, status })
export const setCategories = (data) => ({ type: SET_CATEGORIES, data })
export const isCreatingCategory = (status) => ({ type: IS_CREATING_CATEGORY, status })
export const addCategory = (category) => ({ type: ADD_CATEGORY, category })

/**
 * Loads categories from the backend once per session. The reducer flips its
 * `loaded` flag on the first successful response; the wizard checks it before
 * dispatching so subsequent opens reuse the cached list.
 */
export const loadCategories = () => {
	return async function(dispatch, getState) {
		if (getState().contentAssetCategories.get('loaded')) return
		dispatch(isLoadingCategories(true))
		try {
			const oidcUser = getState().oidc.user
			const { serviceManagementBackendUrl } = window.config
			const config = getAuthorizedConfiguration(oidcUser)
			const url = `${serviceManagementBackendUrl}${CATEGORIES_ENDPOINT}`
			const response = await axios.get(url, config)
			const payload = Array.isArray(response.data) ? response.data : []
			dispatch(setCategories(payload))
		} catch (error) {
			dispatch(setCategories([]))
		} finally {
			dispatch(isLoadingCategories(false))
		}
	}
}

/**
 * Creates a category if no row matches the trimmed name case-insensitively under
 * the same parent slot. Pass `parentId` to create a subcategory; omit (or pass
 * null) to create a top-level. Backend returns the existing category with 200 if
 * a match was found, or a freshly inserted category with 201. Either way the
 * resulting category is appended to the in-memory list and returned to the caller.
 *
 * Throws on network/backend failure so the wizard's optimistic-add can roll back.
 */
export const createCategory = (rawName, parentId = null) => {
	return async function(dispatch, getState) {
		dispatch(isCreatingCategory(true))
		try {
			const oidcUser = getState().oidc.user
			const { serviceManagementBackendUrl } = window.config
			const config = getAuthorizedConfiguration(oidcUser)
			const url = `${serviceManagementBackendUrl}${CATEGORIES_ENDPOINT}`
			const body = parentId != null ? { name: rawName, parentId } : { name: rawName }
			const response = await axios.post(url, body, config)
			const category = response.data
			const existing = getState().contentAssetCategories.get('categories').toJS()
			if (!existing.some((c) => c.Id === category.Id)) {
				dispatch(addCategory(category))
			}
			return category
		} finally {
			dispatch(isCreatingCategory(false))
		}
	}
}
